import { Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY = 'auth.accessToken';
const REFRESH_TOKEN_KEY = 'auth.refreshToken';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  getAccessToken(): string | null {
    return sessionStorage.getItem(
      ACCESS_TOKEN_KEY
    );
  }

  setAccessToken(token: string): void {
    if (!token) {
      this.clearAccessToken();
      return;
    }

    sessionStorage.setItem(
      ACCESS_TOKEN_KEY,
      token
    );
  }

  getRefreshToken(): string | null {
    return sessionStorage.getItem(
      REFRESH_TOKEN_KEY
    );
  }

  setRefreshToken(token: string): void {
    if (!token) {
      this.clearRefreshToken();
      return;
    }

    sessionStorage.setItem(
      REFRESH_TOKEN_KEY,
      token
    );
  }

  hasAccessToken(): boolean {
    return Boolean(
      this.getAccessToken()
    );
  }

  hasRefreshToken(): boolean {
    return Boolean(
      this.getRefreshToken()
    );
  }

  hasSession(): boolean {
    return (
      this.hasAccessToken() ||
      this.hasRefreshToken()
    );
  }

  clearAccessToken(): void {
    sessionStorage.removeItem(
      ACCESS_TOKEN_KEY
    );
  }

  clearRefreshToken(): void {
    sessionStorage.removeItem(
      REFRESH_TOKEN_KEY
    );
  }

  clear(): void {
    this.clearAccessToken();
    this.clearRefreshToken();
  }
}